import { Box, Image, useColorModeValue } from "@chakra-ui/react";
import { useState, useRef } from "react";

export default function Magnifier({
                                      src,
                                      zoom = 2.5,
                                      width = "auto",
                                      height = "600px",
                                      lensSize = 120,
                                      rotation = 0
                                  }) {
    const [hovered, setHovered] = useState(false);
    const [coords, setCoords] = useState({ x: 0, y: 0, bgX: 0, bgY: 0 });
    const imgRef = useRef(null);
    const boxRef = useRef(null);
    const normalizedRotation = ((rotation % 360) + 360) % 360;
    const isRotated = normalizedRotation!==0 && normalizedRotation!==180;

    const handleMouseMove = (e) => {
        if (!imgRef.current || !boxRef.current) return;

        const imgRect = imgRef.current.getBoundingClientRect();
        const boxRect = boxRef.current.getBoundingClientRect();

        // Mouse position related to box
        const mouseX = e.clientX - boxRect.left;
        const mouseY = e.clientY - boxRect.top;

        // Mouse position related to img
        const mouseBgX = e.clientX - imgRect.left;
        const mouseBgY = e.clientY - imgRect.top;

        let bgX, bgY;

        switch (normalizedRotation) {
            case 0:
                bgX = mouseBgX;
                bgY = mouseBgY;
                break;
            case 90:
                bgX = mouseBgY;
                bgY = imgRect.width - mouseBgX;
                break;
            case 180:
                bgX = imgRect.width - mouseBgX;
                bgY = imgRect.height - mouseBgY;
                break;
            case 270:
                bgX = imgRect.height - mouseBgY;
                bgY = mouseBgX;
                break;
            default:
                bgX = mouseBgX;
                bgY = mouseBgY;
        }

        setCoords({
            x: mouseX,
            y: mouseY,
            bgX: bgX,
            bgY: bgY
        });
    };

    const handleMouseEnter = () => {
        setHovered(true);
    };

    const handleMouseLeave = () => {
        setHovered(false);
    };

    const bgImgColor = useColorModeValue("gray.200", "gray.800");

    return (
        <Box
            ref={boxRef}
            position="relative"
            w="100%"
            h={height}
            overflow="hidden"
            borderRadius="md"
            bgColor={bgImgColor}
            justifyContent="center"
            alignItems="center"
            display="flex"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseMove={handleMouseMove}
        >
            <Image
                ref={imgRef}
                src={src}
                maxW="100%"
                maxH="100%"
                w={isRotated ? height : width}
                h={isRotated ? width : height}
                objectFit="contain"
                objectPosition="center"
                cursor="none"
                draggable={false}
                transform={`rotate(${rotation}deg)`}
                transformOrigin="center"
            />

            {hovered && (
                <Box
                    position="absolute"
                    pointerEvents="none"
                    w={`${lensSize}px`}
                    h={`${lensSize}px`}
                    borderRadius="50%"
                    border="2px solid white"
                    boxShadow="0 0 10px rgba(0,0,0,0.3)"
                    top={`${coords.y}px`}
                    left={`${coords.x}px`}
                    zIndex={10}
                    style={{
                        backgroundImage: `url(${src})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: `${(imgRef.current?.offsetWidth || 0) * zoom}px ${(imgRef.current?.offsetHeight || 0) * zoom}px`,
                        backgroundPosition: `${-(coords.bgX * zoom - lensSize / 2)}px ${-(coords.bgY * zoom - lensSize / 2)}px`,
                        transform: `translate(-50%, -50%) rotate(${rotation}deg)`
                    }}
                />
            )}
        </Box>
    );
}